export default {
  "content": "<path d=\"M400 413c34.667-114.182 140.667-192.328 318-234.438S1010 76.93 1062 0h130v413H400z\" fill-rule=\"evenodd\" fill=\"#EFFAFD\"/>",
  "attrs": {
    "width": "1092",
    "height": "413",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};